import { EuiIcon } from '@elastic/eui';
import { UserProfile } from '../../generated/graphql';

import * as S from './UserMenu.styles';

interface UserMenuProps {
  userProfile?: Partial<UserProfile>;
  onClick: () => void;
}

export const UserMenu = ({ onClick, userProfile }: UserMenuProps): JSX.Element => {
  return (
    <S.UserMenuContainer onClick={onClick}>
      <div>
        <p>{`${userProfile?.firstName || '-'} ${userProfile?.lastName || '-'} `}</p>
        {userProfile?.vendorName && <S.Vendor>{userProfile?.vendorName}</S.Vendor>}
      </div>
      <EuiIcon type="arrowUp" />
    </S.UserMenuContainer>
  );
};
